import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';

const SalesChart = ({ data }) => {
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '10px',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      xaxis: {
        categories: [], 
      }
    }
  });

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      const statuses = [...new Set(data.map(item => item.status_name || 'Unknown'))];
      const months = [...new Set(data.map(item => item.year__month || 'Unknown'))];

      const seriesData = statuses.map(status => ({
        name: status,
        data: months.map(month => {
          const item = data.find(
            d => d.status_name === status && d.year__month === month
          );
          return item ? item.cnt : 0; 
        }),
      }));

      setChartData(prevState => ({
        ...prevState,
        series: seriesData,
        options: {
          ...prevState.options,
          xaxis: {
            categories: months,
          },
        },
      }));
    } else {
      setChartData(prevState => ({
        ...prevState,
        series: [],
        options: {
          ...prevState.options,
          xaxis: {
            categories: [],
          },
        },
      }));
    }
  }, [data]);

  return (
    <div className="card">
      <div className="card-body">
        <h4 className="dash-sub-head">Recruitment Statistics</h4>
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={350}
        />
      </div>
    </div>
  );
};

export default SalesChart;
